import { render, staticRenderFns } from "./Requisitos.vue?vue&type=template&id=2fa43ed6"
import script from "./Requisitos.vue?vue&type=script&lang=js"
export * from "./Requisitos.vue?vue&type=script&lang=js"
import style0 from "./Requisitos.vue?vue&type=style&index=0&id=2fa43ed6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports